import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests.js';
import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';
import { FormLayout, FormSection, FormField } from '../../shared/ui/FormLayout';

const CreateCategoryOfVacancyPage = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ title: '' });

  const handleSubmit = async () => {
    if (!form.title.trim()) {
      toast.error('Введите название категории');
      return;
    }
    setSaving(true);
    try {
      await apiRequests.hr.createCategory(form);
      toast.success('Категория успешно создана');
      navigate('/hr/categories');
    } catch (e) {
      toast.error('Произошла ошибка');
    } finally {
      setSaving(false);
    }
  };

  return (
    <FormLayout
      onSubmit={handleSubmit}
      onBack={() => navigate('/hr/categories')}
      saving={saving}
      submitText="Создать"
      savingText="Создание..."
    >
      <FormSection title="Основная информация">
        <FormField label="Название категории" required>
          <Form.Control
            type="text"
            value={form.title}
            onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
            placeholder="Введите название"
            style={{ maxWidth: '400px' }}
          />
        </FormField>
      </FormSection>
    </FormLayout>
  );
};

export default CreateCategoryOfVacancyPage;
